

export const frontMatter = {
	slug: 'dockview-1.8.4-release',
	title: 'Dockview 1.8.4',
	tags: [
		'release'
	]
};
export const contentTitle = 'Release Notes';
export const metadata = {
  "permalink": "/blog/dockview-1.8.4-release",
  "source": "@site/blog/2023-10-06-dockview-1.8.4.md",
  "title": "Dockview 1.8.4",
  "description": "Please reference to docs @ dockview.dev.",
  "date": "2023-10-06T00:00:00.000Z",
  "formattedDate": "October 6, 2023",
  "tags": [
    {
      "label": "release",
      "permalink": "/blog/tags/release"
    }
  ],
  "readingTime": 0.405,
  "hasTruncateMarker": false,
  "authors": [],
  "frontMatter": {
    "slug": "dockview-1.8.4-release",
    "title": "Dockview 1.8.4",
    "tags": [
      "release"
    ]
  },
  "unlisted": false,
  "prevItem": {
    "title": "Dockview 1.9.0",
    "permalink": "/blog/dockview-1.9.0-release"
  },
  "nextItem": {
    "title": "Dockview 1.8.5",
    "permalink": "/blog/dockview-1.8.5-release"
  }
};
export const assets = {
"authorsImageUrls": [],
};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "🚀 Features",
  "id": "-features",
  "level": 2
}, {
  "value": "🛠 Miscs",
  "id": "-miscs",
  "level": 2
}, {
  "value": "🔥 Breaking changes",
  "id": "-breaking-changes",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h2: "h2",
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Please reference to docs @ ", _jsx(_components.a, {
        href: "https://dockview.dev",
        children: "dockview.dev"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "-features",
      children: "🚀 Features"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Optional header actions before tabs list ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/issues/338",
          children: "#338"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "-miscs",
      children: "🛠 Miscs"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Bug: Recover from corrupted layouts gracefully ", _jsx(_components.a, {
            href: "https://github.com/mathuo/dockview/issues/341",
            children: "#341"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Bug: Fix floating group resizing within nested tabs ", _jsx(_components.a, {
            href: "https://github.com/mathuo/dockview/issues/344",
            children: "#344"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Bug: Progmatic resizing priority ", _jsx(_components.a, {
            href: "https://github.com/mathuo/dockview/issues/350",
            children: "#350"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Bug: Incorrect disposal of deeply nested gridview ", _jsx(_components.a, {
            href: "https://github.com/mathuo/dockview/issues/356",
            children: "#356"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Splitview separator stlye restored on deserialize step ", _jsx(_components.a, {
            href: "https://github.com/mathuo/dockview/issues/358",
            children: "#358"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Docs: Additional Docs ", _jsx(_components.a, {
            href: "https://github.com/mathuo/dockview/issues/347",
            children: "#347"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Docs: Additional Docs ", _jsx(_components.a, {
            href: "https://github.com/mathuo/dockview/issues/336",
            children: "#336"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Docs: Additional Docs ", _jsx(_components.a, {
            href: "https://github.com/mathuo/dockview/issues/352",
            children: "#352"
          })]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "-breaking-changes",
      children: "🔥 Breaking changes"
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

